/**
 * 56yorky 代理 API 文档（来自 56yorky_logistics_api_collection_with_docs.json）
 * 用于代理能力滑窗中展示 API 定义：URL、参数、文档等
 */
import collection from './56yorky_api_collection.json';

export interface Yorky56ApiHeader {
  key: string;
  value: string;
  type?: string;
}

export interface Yorky56ApiQueryParam {
  key: string;
  value?: string;
  description?: string;
}

export interface Yorky56ApiUrl {
  raw: string;
  host?: string[];
  path?: string[];
  query?: Yorky56ApiQueryParam[];
}

export interface Yorky56ApiRequest {
  method: string;
  header?: Yorky56ApiHeader[];
  url?: Yorky56ApiUrl;
  body?: { mode?: string; raw?: string };
  description?: string;
}

export interface Yorky56ApiItem {
  name: string;
  request?: Yorky56ApiRequest;
}

const itemList: Yorky56ApiItem[] = (collection as { item?: Yorky56ApiItem[] }).item ?? [];
const byName: Record<string, Yorky56ApiItem> = {};
itemList.forEach((i) => {
  byName[i.name] = i;
});

/** 按 API 名称获取 56yorky 接口定义，用于展示详情 */
export function get56yorkyApiByName(apiName: string): Yorky56ApiItem | undefined {
  return byName[apiName];
}

/** 路径片段拼接为完整路径（不含 base_url） */
export function getApiPath(item: Yorky56ApiItem): string {
  const path = item.request?.url?.path;
  if (!path?.length) return '';
  return '/' + path.join('/');
}
